/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ShipmentVoModel } from './shipment-vo.model';
import { AccountVoModel, ShipmentGroupStatusVoModel } from '@well/domain';
import { DelEmployeeVoModel } from '@well/delivery-libs/employee/domain';

export class ShipmentGroupVoModel extends JSONable {
  uuid: string | undefined = undefined;
  serviceProviderOrderUuid: string | undefined | null;
  documentNumber: string | undefined = undefined;
  customerName: string | undefined = undefined;
  customerUuid: string | undefined = undefined;
  deleted: boolean | undefined = undefined;
  shipments: Array<ShipmentVoModel> | undefined = undefined;
  employeeVO: DelEmployeeVoModel | undefined = undefined;
  firstDeadline: string | undefined = undefined;
  isNewlyCreated: boolean | undefined = undefined;
  offerRequestUuid: string | undefined = undefined;
  orderUuid: string | undefined = undefined;
  statusVo: ShipmentGroupStatusVoModel | undefined = undefined;
  serviceProviderOfferRequestUuid: string | undefined = undefined;
  accountVO: AccountVoModel | undefined | null;
  preferredMasterRSUuid: string | undefined = undefined;
  termsAndConditionsSeen: boolean | undefined = undefined;
  paymentTimeLimit: string | undefined = undefined;

}
